export const aicaSimulatingAlert = "Document is being simulated by AICA&reg;, Please wait ...";
export const aicaPostingAlert = "Document is being posted by AICA&reg;, Please wait ...";
export const aicaPostedAlert = "Document has been posted by AICA&reg;";